import React from 'react';

import ListItem from './ListItem';
import ItemContent from './ItemContent';

const AnchorItem = ({ onClick, className, ...rest }) => (
  <ListItem className={className}>
    <a
      href="/#"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <ItemContent {...rest} />
    </a>
  </ListItem>
);

export default AnchorItem;
